<template lang="html">
    <list-template ref="list-template" actionUrl="plusActivity/findActivity.action" :queryParams="queryParams">
      <template slot="search" scope="scope">
        <el-button type="primary" style="margin-right:20px;" @click="$router.push('addPlusActivity')">发布新活动</el-button>
      </template>
      <template slot="item" scope="scope">
        <el-card class="basic-margin" v-for="data in scope.datas">
           <el-row>
            <el-col :span="3">
              <img :src="data.imgLink" style="width:150px;height:100px;">
            </el-col>

            <el-col :span="12">

              <h4>{{data.title}}</h4>
              <div v-if="loginInfo.loginPath=='cxh'">已投放地区{{data.channelCount}} 个 渠道 <el-tag type="success" size="mini" style="margin-top:10px;margin-left:5px;">{{data.status | statusFilter}}</el-tag></div>

              <div style="color:#999999;">更新时间 {{data.createTime | dateTimeFormat}}</div>

              <!-- <template v-if="data.channelName&&loginInfo.loginPath=='cxh'">
                <el-tag size="small" style="margin-right:10px;margin-top:5px;" v-for="tag in data.channelName.split(',')">{{tag}}</el-tag>
              </template> -->
            </el-col>
            <el-col :span="9" style="text-align:right;">
              <el-button type="text" @click="$router.push({name:'修改活动', params: { id: data.id }})">修改活动</el-button>
              <el-button type="text" v-confirm confirm-text="确定刷新广告" requestUrl="plusActivity/refreshActivity.action" :confirm-data="{id:data.id}" @onConfirm="$refs['list-template'].search()">刷新</el-button>
              <el-button type="text" v-confirm confirm-text="确定删除活动" requestUrl="plusActivity/delActivity.action" :confirm-data="{id:data.id}" @onConfirm="$refs['list-template'].search()">删除</el-button>
              <el-button type="text" v-confirm :confirm-text="data.status==2?'确定上架活动':'确定下架活动'" requestUrl="plusActivity/lowerShelfActivity.action" :confirm-data="{id:data.id}" @onConfirm="$refs['list-template'].search()">{{data.status==2?'上架':'下架'}}</el-button>
            </el-col>

          </el-row>
        </el-card>
      </template>
    </list-template>
</template>

<script>
import ListTemplate from '@/components/ListTemplate'
import BasicPager from '@/mixins/BasicPager'
import Config from '@/framework/configs/Config'
export default {
  name: 'plus-activity',
  extends: BasicPager,
  components: {
    ListTemplate
  },
  data: function () {
    return {
      imageUrl: Config.imageUrl,
      queryParams: {
        isSxb: 1
      }
    }
  },
  filters: {
    statusFilter: function (valueFilter) {
      let str = ''
      switch (valueFilter) {
        case 2:
          str = '已下架'
          break
        case 1:
          str = '已上架'
          break
        default:
          str = '暂无'
      }

      return str
    }
  },
  created: function () {
    if (this.loginInfo.loginPath == 'channel') {
      this.queryParams.isSxb = 0
    } else {
      this.queryParams.isSxb = 1
    }
  }
}
</script>

<style lang="css" scoped>
</style>
